import { EVENT_DATA} from "../../constants/ActionTypes";

const INIT_STATE = {
    events: []
};

const eventReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case EVENT_DATA: {
            return {
                ...state,
                events: action.payload,
            }
        }
        default:
            return state;
    }
}

export default eventReducer;
